<template>
  <base-dialog
    :showDialog="showDialog">
    <template v-slot:body>
        <v-card dark>
            <v-card-title>
                Categoria Integração
            </v-card-title>
            <v-card-text>
                <div class="flex-wrap d-flex">
                    <v-text-field class="mx-1 text-caption" label="Nome" dark dense outlined v-model="category.NOME"/>
                    <v-text-field class="mx-1 text-caption" disabled label="Id" dark dense outlined v-model="category.ID"/>
                    <v-text-field class="mx-1 text-caption" label="Subtítulo" dark dense outlined v-model="category.SUBTITULO"/>
                    <v-combobox class="mx-1 text-caption"   label="Categoria Pai" :items="comboBoxCategories" item-text="NOME" item-value="CODIGO" dark dense outlined v-model="category.PARENT_ID"/>
                </div>
            </v-card-text>
            <form-buttons
                @goBack="$emit('goBack')"
                @submitForm="submitForm"
            />
        </v-card>
    </template>
  </base-dialog>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import service from '@/services/integration/iset/IsetService'
export default {
    computed:{
        ...mapGetters({comboBoxCategories: 'isetModule/getCategoryComboBox'})
    },
    data:() => {
        return {
            category: {}
        }
    },
    methods:{
        ...mapActions({getCategoriesIntegration: 'isetModule/getCategories',
                        showLoadingDialog: 'dialogModule/setShowLoadingDialog',
                        setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage'}),        
        submitForm(){
            if(this.category.PARENT_ID)
                this.category.PARENT_ID = this.category.PARENT_ID.CODIGO == null ? 0 : this.category.PARENT_ID.CODIGO
            this.$emit('submitForm', this.category)
        },
        async requestCategories(){
            await this.getCategoriesIntegration({todos:'S', integrados:'S'})
        },        
        async requestCategoryData(){ 
            this.setLoadingDialogMessage(`Consultando Categoria [${this.category.ID}]`)
            this.showLoadingDialog(true)
            try{
                
                let response = await service.getCategoryIntegration(this.category.ID)

                if(response.data.PARENT_ID > 0){
                    let parent = this.comboBoxCategories.find((category) => category.CODIGO == response.data.PARENT_ID)  
                    this.category.PARENT_ID = parent
                }
                if(response.data.SUBTITULO != null)
                    this.category.SUBTITULO = response.data.SUBTITULO
                if(response.data.NOME != null)
                    this.category.NOME = response.data.NOME
            }catch(error){
                this.$toasted.error(error)
            }finally{
                this.showLoadingDialog(false)
            }
        }
    },
    mounted(){
        this.requestCategories()        
        if(this.objectData.ID){
            this.category = {...this.objectData}
            this.requestCategoryData()
        }
    },
    components:{
        BaseDialog: () => import('@/components/shared/base-dialog/BaseDialog'),
        FormButtons: () => import('@/components/shared/base-buttons/FormButtons')   
    },
    props:{
        showDialog: {
            type:Boolean,
            default: false,
            required: true
        },
        objectData : {
            type: Object,
            default: () => {},
            required: true
        }
    }
}
</script>

<style>

</style>